// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2dw2sdVEZfQmeM {\n  width: 100%;\n  min-height: 160px;\n}\n._3wW7_YRXIzN8ux {\n  text-align: center;\n  display: inline-block;\n  margin: 10px;\n  justify-content: center;\n  align-items: center;\n  min-height: 160px;\n  width: 100%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBackStaticMap": "_2dw2sdVEZfQmeM",
	"cardBackStaticMapError": "_3wW7_YRXIzN8ux"
};
export default ___CSS_LOADER_EXPORT___;
